export default "__VITE_ASSET__Cj4F2Y1G__"